// import axios from 'axios'
import { post, put, get } from "@/api/api";

export const actions = {
  fetchAttributs({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/attribut`).then(({ data }) => {
      commit("addAttributs", data);
    });
  },
  async fetchAttributsPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
    }).toString();

    let { data } = await get(`/canal/attribut/page?${queryParams}`);
    commit("addAttributsPage", data)
    return data;
  },
  createAttribut({ commit }, attribut) {
    return post("/canal/attribut", attribut).then(({ data }) => {
      commit("addAttribut", data);
    });
  },
  updateAttribut({ commit }, attribut) {
    return put(`/canal/attribut${attribut.id}`, attribut).then(({ data }) => {
      commit("replaceAttribut", data);
    });
  },
  createOrUpdateAttribut({ dispatch }, attribut) {
    if (attribut.id !== undefined) {
      return dispatch("updateAttribut", attribut);
    } else {
      return dispatch("createAttribut", attribut);
    }
  },
  selectAttribut({ commit }, attribut) {
    commit("setAttribut", attribut);
  },
};
